"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.crunch = void 0;
var JSON_1 = require("../JSON");
var utils_1 = require("../utils");
function flatten(data, set) {
  if (!(0, JSON_1.isContainer)(data)) {
    return (0, utils_1.encode)(data);
  }
  var recurse = function recurse(data) {
    return flatten(data, set);
  };
  var flattened = (0, JSON_1.map)(data, recurse);
  var position = set.add(flattened);
  return (0, utils_1.encode)(position, {
    reference: true
  });
}
// Any values that are only used once are hoisted into their container
// and zeroed out.
function compact(set) {
  var values = set.values,
    counts = set.counts;
  values.forEach(function (container) {
    (0, JSON_1.forEach)(container, function (value, key) {
      if (!(0, utils_1.isReference)(value)) {
        return;
      }
      var index = (0, utils_1.decode)(value);
      var count = counts[index];
      if (count != null && count > 1) {
        return;
      }
      // Typescript doesn't know if this is an object or array
      // but `forEach` ensures safety here for us
      container[key] = values[index];
      values[index] = 0;
    });
  });
}
function crunch(data) {
  if (!(0, JSON_1.isContainer)(data)) {
    return [(0, utils_1.encode)(data)];
  }
  var set = (0, utils_1.CountedOrderedSet)();
  flatten(data, set);
  compact(set);
  return set.values;
}
exports.crunch = crunch;